export default {"src":"/_next/static/media/climbing.4db75411.svg","height":64,"width":64,"blurWidth":0,"blurHeight":0};